module.exports = __webpack_public_path__ + "media/images/shared/logotypes/logo_umea-2071c75c96daf4e6d60ce77304b90f6b.png";